var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveandpeace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.886 34.688c-10.106-.02-20.147 1.212-29.89 3.646-51.954 12.984-95.682 59.773-97.782 126.98-1.12 35.802 9.933 65.568 27.54 91.12 17.61 25.552 41.55 47.156 66.847 68.44 50.597 42.573 106.392 83.872 132.4 148.294l8.903 22.05 8.49-22.212c24.648-64.483 78.63-107.776 128.604-151.27 49.974-43.493 96.634-88.202 98.783-155.833 2.275-71.536-42.364-116.7-95.523-127.137-49-9.622-105.34 9.122-140.23 57.744-27.546-42.14-68.33-61.74-108.14-61.822zm108.43 90.36l92.414 115.144c-17.518-4.413-34.638-7.367-51.426-9.104l-40.988-51.068-41.475 51.678c-17.227 1.92-34.183 4.84-50.938 8.496zm10.964 104.22c3.744.203 7.524.536 11.338.998 23.128 58.72 94.71 72.16 144.393 37.942-12.702 13.278-27.086 26.205-42.282 39.43-13.117 11.417-26.774 23.008-40.272 35.16-38.64-3.292-79.145-49.547-73.176-113.53zm-22.613.21c5.097 64.43-37.687 112.014-77.23 115.173-13.762-11.76-27.61-22.97-40.805-34.073-14.815-12.465-28.802-24.828-41.06-37.637 49.857 39.712 124.645 21.8 147.51-42.287 3.834-.497 7.693-.895 11.585-1.174z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveandpeace);
export default __webpack_public_path__ + "static/media/loveandpeace.45f8e07c1f094dd7c6e20a8d5a6df7d7.svg";
export { ForwardRef as ReactComponent };